<template>
    <z-scrollDiv class="task-info-wrap" :class="{hasBtn:process_flag}" @scroll="hide_change = !hide_change">
        <!-- 任务的表单 -->
        <div class="mod-title border">{{ task_id == 0?"任务创建：":"任务详情：" }}<span v-if="task_id == 0 || (detail_data.category_status == 10 && detail_data.start_status == 10)" class="tip">红色标志为必填项</span></div>
        <detail-form :name="'task_detail'" :hide="hide_change" :sub="sub_data" :read="read_judge" :detailData="detail_data" @refresh="getDetailData"  @openDoc="$emit('openDoc')"></detail-form>

        <!-- 关联任务  文档管理 -->
        <div class="mod-title border" v-show="task_id != 0"></div>
        <div class="alone-func">
            <transition name="up">
                <div class="relation" v-if="task_id != 0">
                    <div class="mod-title">关联任务：</div>
                    <relation :read="read_judge" :detailData="detail_data"></relation>
                </div>
            </transition>
            <transition name="up">
                <div class="remark" v-if="detail_data.category_status != undefined && !(detail_data.category_status == 10 && (detail_data.process_status == 101 || detail_data.process_status == 103) )">
                    <div class="mod-title">任务备注：</div>
                    <remarks :read="read_judge" :detailData="detail_data" @openDoc="$emit('openDoc')"></remarks>
                </div>
            </transition>
        </div>

        <!-- 流程按钮 -->
        <processBtn class="process-btns" v-show="process_flag" :buType = "bu_type" :sub="sub_data" :detailData="detail_data" @refresh="getDetailData"></processBtn>

    </z-scrollDiv>
</template>


<script>
    import detailForm from "./detail-form.vue"
    import remarks from "./remark.vue"
    import relation from "./relation-task.vue"
    import processBtn from "./process-btn.vue"

    import { mapState } from "vuex"

    export default {
        components: {
            remarks,
            detailForm,
            relation,
            processBtn,
        },

        data() {
            return {
                detail_data:{},  //任务详情数据

                sub_data:{   // 提交的数据
                    tempId: '',    //任务模板id
                    buId: '',       //接收的bu id
                    taskName: "",   //任务名称
                    taskDescribe: '',  //任务描述
                    taskCycle: '',     //任务周期  
                    // currencyId: '',       //快币类型id
                    fastBonus: '',      //  快币奖金
                    uploadDoc:[],   //上传的文件

                    person:"",  //执行者 id
                    require_doc:[],    //已有的文档
                    deldocId: [],    //需要删除的文档id
                },  

                hide_change:false,
            }
        },
    
        computed: {
            ...mapState(["buInfo"]),
            task_id(){   //task id
                let str = this.$route.params.task_id;
                return this.$crypto.decrypt(str);
            },
            read_judge(){   //冻结任务判断
                let  data = this.detail_data;
                let status = data.category_status;
                let process = data.process_status;

                let arr = [
                    status == 10 && process == 102,   //审核中
                    status == 20 && process == 202,   //拒收待确认,
                    status == 20 && process == 204,   //验收中,
                    status == 20 && process == 205,   //取消中
                    status == 20 && process == 206,   //取消中(管理员)
                    status == 20 && process == 207,   //投诉中
                    status == 30,    //任务已结束
                ];

                return arr.some(val=>val);
            },


            bu_type(){   //  发布方/接收方
                if(this.buInfo.id == this.detail_data.pub_bu_id){  //发布方
                    return 1;
                }else if (this.buInfo.id == this.detail_data.sub_bu_id){  //接收方
                    return 2;
                }
            },

            process_flag(){
                let status = this.detail_data.category_status;
                let process = this.detail_data.process_status;
                
                if(this.task_id == 0){  // 创建任务时
                    return true;
                }

                switch (this.bu_type) {
                    case 1:    //发布方
                        let arr = [
                            status == 10 && process != 102,
                            status == 20 && process == 202, 
                            status == 20 && process == 204,
                            status == 20 && process == 205,
                        ]
                        return  arr.some(val=>val);

                
                    case 2:  //接收方
                        let arr2 = [
                            status == 20 && process == 201, 
                            status == 20 && process == 203,
                        ]
                        return arr2.some(val=>val);
                }
            },
        },

        watch:{
            "$route.params.task_id"(){
                this.getDetailData();
            }
        },

        created() {
            this.getDetailData();
            this.$func.getUserBu(true);   //获取登录用户BU
            this.$func.getTaskTpl(true);  //更新任务类型
            this.$func.getCurrencyList(true);  //更新快币类型
        },

        methods: {
            getDetailData(id = this.task_id){
                if(id != 0 ){
                    let url = `api/clerk/task/${id}`
                    this.$http.get(url).then(res => {
                        if(res.status == 200){
                            this.detail_data = res.res_data;
                        }
                    });
                }
            },
            oh(){
                console.log(`enenen`)
            },
        },

    }
</script>

<style lang="less">
    @import "~src/assets/less/var.less";
    @padd:30px;
    @btn-h:60px;

    .task-info-wrap{
        color:#333;
        box-sizing:border-box;
        padding:10px @padd 0;
        // height:100%;
        position: relative;
        &.hasBtn{
            padding-bottom:@btn-h;
        }


        // 模块头部
        .mod-title{
            font-size:14px;
            padding-bottom:10px;
            font-weight:600;
            &.border{
                border-bottom: 1px dashed @detail_border;
            }
            .tip{
                color:#999;
                font-size:12px;
                font-weight:500;
            }
        }

        //虚线分割
        // .border{  
        //     position: absolute;
        //     width:calc(~"100% - 30px*2");
        //     height: 0;
        //     border-top: 1px dashed @detail_border;
        //     // left:0;
        // }

        // 独立部分
        .alone-func{
            margin-top :20px;
            margin-bottom: 10px;
            max-width: 1000px;
            // padding-bottom :25px;
            // width:calc(~"@{screen} - @{front_side_w} - @{front_padd}");
            overflow:hidden;
            .relation,.remark{
                float: left;
            }
            .relation{
                width:calc(~"100% - @{detail_right}");
            }
        }

        // 流程按钮
        .process-btns{
            position: absolute;
            width:100%;
            bottom:0;
            left: 0;
            height: @btn-h;
            line-height: @btn-h;
            // text-align: center;
            padding-left: @padd;
            box-sizing:border-box;
            box-shadow:0 -1px 4px 0 #c3c6c9;
        }
    }
</style>



// WEBPACK FOOTER //
// task-detail.vue?fd39f15c